<template>
    <v-card>
        <v-data-table
            :headers="headers"
            :items="emitterReportData"
            :server-items-length="total"
            :loading="reportTableLoading"
            :hide-default-footer="hideFooter"
            :options.sync="options"
            :footer-props="getFooterProps()"
        >
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    name: "EmitterReportTable",

    props: {
        limit: {
            type: Number,
            default: null,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
        hideQuery: {
            type: Boolean,
            default: false,
        }
    },

    data: () => ({
        emitterReportData: [],
        reportTableLoading: true,
        total: 0,
        query: '',
        filter: {},
        options: {
            sortDesc: [true],
        },
        headers: [
            {text: 'Emissor', value: 'emitterName', sortable: false},
            {text: 'Qtd de reservas confirmadas/canceladas', value: 'totalEmittedBookings', sortable: true},
        ]
    }),

    methods: {
        setFilter(filter) {
            this.filter = {
                'emitterName': filter.emitterName ?? '',
                'emittedStartDate': filter.emittedStartDate ?? filter.startDate ?? '',
                'emittedUntilDate': filter.emittedUntilDate ?? filter.finalDate ?? '',
            };
        },

        setQueryString() {
            this.query = `page=${this.options.page}&perPage=${this.options.itemsPerPage}&sortBy=${this.options.sortBy}&sortDesc=${this.options.sortDesc}&limit=${this.limit ?? ''}` +
            `&emitterName=${this.filter.emitterName}&emittedStartDate=${this.filter.emittedStartDate}&emittedUntilDate=${this.filter.emittedUntilDate}`;
        },

        pushQueryToRouter() {
            if (!this.hideQuery) {
                this.$router.push({
                    query: {
                        'page': this.options.page,
                        'perPage': this.options.itemsPerPage,
                        'sortBy': this.options.sortBy,
                        'sortDesc': this.options.sortDesc,
                        'emitterName': this.filter.emitterName,
                        'emittedStartDate': this.filter.emittedStartDate,
                        'emittedUntilDate': this.filter.emittedUntilDate,
                    }
                });
            }
        },

        getReportData(filter = {}) {
            this.reportTableLoading = true;
            this.setFilter(filter);
            this.setQueryString();
            this.pushQueryToRouter();
            axios.get(`/api/reports/emitter?${this.query}`)
                .then(res => {
                    this.emitterReportData = res.data.data;
                    this.total = res.data.total;
                    this.reportTableLoading = false;
                })
        },

        getFooterProps() {
            if (this.hideFooter) {
                return {itemsPerPageOptions: [10]};
            }
            return {itemsPerPageOptions: [10, 15, 30]};
        },

        getOptionsFromUrlQuery() {
            if(Object.keys(this.$route.query).length) {
                const {
                    page,
                    perPage,
                    sortBy,
                    sortDesc,
                } = this.$route.query;
                if (page) {
                    this.options.page = parseInt(page ? page : 1);
                }
                if (perPage) {
                    this.options.itemsPerPage = perPage;
                }
                if (sortBy) {
                    this.options.sortBy = sortBy;
                }
                if (sortDesc) {
                    this.options.sortDesc = sortDesc;
                }
            }
        },
    },

    mounted() {
        this.getOptionsFromUrlQuery();
    },

    watch: {
        options: {
            handler() {
                if (!this.hideQuery) {
                    this.getReportData(this.filter);
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>
